import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import { playerReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";

export default class PatReturned extends Fragment {
    constructor(returnedBy) {
        super();
        this.returnedBy = returnedBy;

        this.requiredData = [
            {
                name: "returnedBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Returned By",
                title: (team) => `Returned By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            }
        ];
    }

    getPlayers() {
        return [this.returnedBy];
    }

    summarize(summaryContext, stringifier) {
        const message = `, ${stringifier.firstInitial(
            this.returnedBy
        )} returned`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            returnedBy: playerReducer(this.returnedBy)
        };
    }
}
